export enum OrganizationRoleEnum {
    USER = 'USER',
    DEVELOPER = 'DEVELOPER',
    VIEWER = 'VIEWER',
    ADMIN = 'ADMIN',
    OWNER = 'OWNER',
    SUPERVISOR = 'SUPERVISOR',
}
